export class HomeComponent {
  header = "Home Page";
}
